import { namespace } from 'vuex-class';
import { ISearchState } from '@/content-library/search/store/search.types';

export const Search = namespace('contentLibrary/search');

export enum ESearchState {
  RecentSearches = 'recentSearches',
  AutocompleteSuggestions = 'autocompleteSuggestions',
  Loaded = 'loaded',
  Loading = 'loading',
}

export const state: ISearchState = {
  [ESearchState.RecentSearches]: [],
  [ESearchState.AutocompleteSuggestions]: [],
  [ESearchState.Loaded]: false,
  [ESearchState.Loading]: false,
};

export enum ESearchAction {
  AddRecentSearch = 'addRecentSearch',
  RemoveRecentSearch = 'removeRecentSearch',
  LoadAutocomplete = 'loadAutocomplete',
  LoadAutocompleteSuccess = 'loadAutocompleteSuccess',
  LoadAutocompleteFailed = 'loadAutocompleteFailed',
  ResetAutocompleteSuggestions = 'resetAutocompleteSuggestions',
}

export enum ESearchMutation {
  SetRecentSearches = 'setRecentSearches',
  SetAutocompleteSuggestions = 'setAutocompleteSuggestions',
  SetLoading = 'loading',
  SetLoaded = 'loaded',
}

export enum ESearchGetters {
  RecentSearchItems = 'recentSearchesSection',
  AutocompleteSearchItems = 'autocompleteSection',
}
